import { Routes } from '@angular/router';
import { authGuard } from '@libs/security/guards/auth-guard';
import {
  ComingSoonComponent,
  DataEntryPageComponent,
  FacilityBedsEditorPage,
  HelpPage,
  NotFoundComponent,
  TemporarilyUnavailableComponent,
} from './features';
import { AccountChanges } from './features/help/components/account-changes/account-changes';
import { EmailSupport } from './features/help/components/email-support/email-support';
import { FrequentlyAskedQuestions } from './features/help/components/frequently-asked-questions/frequently-asked-questions';
import { GettingNumbersRight } from './features/help/components/getting-numbers-right/getting-numbers-right';
import { HelpAndSupport } from './features/help/components/help-and-support/help-and-support';
import { SmokingPolicy } from './features/help/components/smoking-policy/smoking-policy';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/view-entries',
    pathMatch: 'full',
  },
  {
    path: 'view-entries',

    loadComponent: () =>
      import('./features').then((m) => m.ViewEntriesPageComponent),
    canActivate: [authGuard],
    children: [
      {
        path: ':id/edit',
        component: DataEntryPageComponent,
      },
    ],
  },
  {
    path: 'v2/capacity-reporting',

    loadComponent: () =>
      import('./features').then((m) => m.CapacityReportingPage),
    canActivate: [authGuard],
    children: [
      {
        path: ':id/edit',
        component: FacilityBedsEditorPage,
      },
    ],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features').then((m) => m.UnauthorizedComponent),
  },
  {
    path: 'insufficient-privileges',
    loadComponent: () =>
      import('./features').then((m) => m.InsufficientPrivilegesComponent),
  },
  {
    path: 'error',
    loadComponent: () => import('./features').then((m) => m.ErrorComponent),
  },
  { path: 'page-not-found', component: NotFoundComponent },
  { path: 'coming-soon', component: ComingSoonComponent },
  {
    path: 'temporarily-unavailable',
    component: TemporarilyUnavailableComponent,
  },
  {
    path: 'help',
    component: HelpPage,
    children: [
      {
        path: '',
        redirectTo: 'help-and-support',
        pathMatch: 'full',
      },
      {
        path: 'help-and-support',
        component: HelpAndSupport,
      },
      {
        path: 'getting-numbers-right',
        component: GettingNumbersRight,
      },
      {
        path: 'account-changes',
        component: AccountChanges,
      },
      {
        path: 'smoking-policy',
        component: SmokingPolicy,
      },
      {
        path: 'frequently-asked-questions',
        component: FrequentlyAskedQuestions,
      },
      {
        path: 'email-support',
        component: EmailSupport,
      },
    ],
  },
  { path: '**', redirectTo: 'page-not-found' },
];
